
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import Chip from '../Chip';

import { getColorForImportance } from '../../utils/enumHelper';
import styles from './styles';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    border: `1px solid ${theme.palette.background.paper}`,
    width: '10px',
    height: '10px',
  },
}));

export const getHorsePictureUrl = (horse) => {
  let barnHorseUri = `https://i0.wp.com/cdn.auth0.com/avatars/${(horse && (horse.name || 'H')).charAt(0).toLowerCase()}.png`;
  if ((horse && horse.picture) && horse.picture.indexOf('data:image/jpg;base64') >= 0) {
    barnHorseUri = horse.picture;
  } else if ((horse && horse.picture)) {
    barnHorseUri = `https://${horse.picture}?cacheBust=${new Date()}`
  }

  return barnHorseUri
}

const HorseComonent = ({
  bordered,
  chip,
  horse,
  align,
  classes,
  hideName,
  hideShowName,
  size,
  chipSize,
  onClick,
  clickable,
  variant,
  flexDirection,
  textWidth,
  showActiveNoteIndicator = false,
  ...rest
}) => {
  if (!horse || !horse.id) return <Box />

  const picture = getHorsePictureUrl(horse);

  const avatar = (
    <StyledBadge
      color={getColorForImportance(horse.activeNote
        ? horse.activeNote.importance
        : 'https://i.imgur.com/tHcI4iD.png')}
      overlap="circular"
      variant="dot"
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      invisible={!horse.activeNote}
    >
      <Avatar
        alt={horse.name}
        src={`${picture}?lastModified=${(horse && horse.modifiedTimestamp) || true}`}
        onClick={onClick}
        sx={[{ color: 'action.active' }, chip
          ? { width: (((chipSize === 'l' || chipSize === 'xl') && 24) || 18) }
          : { width: size }, chip
          ? { height: (((chipSize === 'l' || chipSize === 'xl') && 24) || 18) }
          : { height: size }, clickable
          ? { cursor: 'pointer' }
          : { cursor: 'default' }]}
      />
    </StyledBadge>
  );

  if (hideName) {
    return avatar;
  }

  return (!chip
    ? (
      <Box
        onClick={onClick}
        sx={[{
          display: 'flex',
          alignItems: (flexDirection && flexDirection === 'column')
            ? 'flex-start'
            : 'center',
          justifyContent: align,
          flexDirection,
        }, clickable
          ? { cursor: 'pointer' }
          : { cursor: 'default' }]}
      >
        {avatar}
        <Box
          sx={{
            ml: (flexDirection && flexDirection === 'column')
              ? 0
              : 1,
            width: textWidth || 'inherit',
            maxWidth: 200,
          }}
        >
          <Typography component="h3" noWrap className={classes.horseName}>{horse.name}</Typography>
          {
            showActiveNoteIndicator && horse.activeNote && (
              <Chip size="small" label={horse.activeNote.title} color={getColorForImportance(horse.activeNote.importance)} disableGutters />
            )
          }
          {(
            !(showActiveNoteIndicator && horse.activeNote) && horse.showName && <Typography noWrap component="div" className={classes.horseShowName}>{horse.showName}</Typography>
          )}

        </Box>
      </Box>
    )
    : (
      <Chip
        avatar={avatar}
        label={horse.name}
        disableGutters
        showDelete={false}
        variant={variant}
        size={((chipSize === 'l' || chipSize === 'xl') && 'large') || 'small'}
        color={horse.activeNote
          ? getColorForImportance(horse.activeNote.importance)
          : 'default'}
        clickable={clickable}
        onClick={(e) => {
          e.stopPropagation();
          if (typeof onClick === 'function') onClick();
        }}
        {...rest}
      />
    ));
};

HorseComonent.propTypes = {
  bordered: PropTypes.bool,
  chip: PropTypes.bool,
  align: PropTypes.string,
  horse: PropTypes.object.isRequired,
  classes: PropTypes.object,
  hideName: PropTypes.bool,
  hideShowName: PropTypes.bool,
  size: PropTypes.any,
  chipSize: PropTypes.string,
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
  variant: PropTypes.string,
  flexDirection: PropTypes.string,
  textWidth: PropTypes.number,
};

HorseComonent.defaultProps = {
  bordered: false,
  align: 'flex-start',
  chip: false,
  classes: {},
  hideName: false,
  hideShowName: false,
  size: 40,
  onClick: null,
  clickable: false,
  variant: 'outlined',
  flexDirection: 'row',
  textWidth: null,
  chipSize: null,
};

export default withStyles(styles)(HorseComonent);
